// extracted by mini-css-extract-plugin
module.exports = {"animation":"SpeedTestAnimation_animation__2kUkv"};